"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StopOnBonusTriggeredToggleBtn = void 0;
const IconToggleButton_1 = require("@nolimit/slot-launcher/bin/gui/buttons/IconToggleButton");
const PointerStateColorSet_1 = require("@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PointerStateIconSet_1 = require("@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimit/slot-launcher/bin/gui/displayobjects/Icon");
const GuiDefaults_1 = require("@nolimit/slot-launcher/bin/gui/default/GuiDefaults");
const Label_1 = require("@nolimit/slot-launcher/bin/gui/labels/Label");
const NolimitPromotionPlugin_1 = require("../../../NolimitPromotionPlugin");
const PromoPanelAssetConfig_1 = require("../../../config/PromoPanelAssetConfig");
const ActionSpinsController_1 = require("../ActionSpinsController");
class StopOnBonusTriggeredToggleBtn extends IconToggleButton_1.IconToggleButton {
    constructor(name, labelString) {
        const onColors = new PointerStateColorSet_1.PointerStateColorSet(0xFFFFFC00, 0xFFFFFC00, 0xFFFFFC00, 0x33FFFC00);
        const offColors = new PointerStateColorSet_1.PointerStateColorSet(0xFFFFFFFF, 0xFFFFFFFF, 0xFFFFFFFF, 0x33FFFFFF);
        const flippedTexture = NolimitPromotionPlugin_1.NolimitPromotionPlugin.imgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.ACTION_SPINS_GAME_CHECK_BOX_ACTIVE).clone();
        const offIcons = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(NolimitPromotionPlugin_1.NolimitPromotionPlugin.imgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.ACTION_SPINS_GAME_CHECK_BOX_INACTIVE)));
        const onIcons = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(flippedTexture.clone()));
        super(name, onIcons, onColors, offIcons, offColors);
        this.toggleState = 0;
        this.enable(true);
        this.addClickCallback(() => this.changeBtnState());
        if (labelString != undefined) {
            const label = new Label_1.Label(labelString, GuiDefaults_1.GuiDefaults.DEFAULT_RADIO_BUTTON_LABEL);
            label.anchor.set(0, 0.5);
            this.addSubComponent(label, { x: 1, y: 0.5 }, { x: 20, y: 0 });
        }
    }
    changeBtnState() {
        NolimitPromotionPlugin_1.NolimitPromotionPlugin.sound.playKeypadEffect("click");
        this.toggleState = Number(!this.toggled);
        ActionSpinsController_1.ActionSpinsController.settings.stopOnBonus = this.toggled;
    }
}
exports.StopOnBonusTriggeredToggleBtn = StopOnBonusTriggeredToggleBtn;
//# sourceMappingURL=StopOnBonusTriggeredToggleBtn.js.map